"use strict";

import React from "react";
import cx from "classnames";

function ControlStatic(props) {
  let { type, text, value, children, baseClassName, className, ...otherProps } = props;

  return (
    <div className={cx(baseClassName, className)} {...otherProps}>
      {children}
      {text}
      {value}
    </div>
  );
}

ControlStatic.defaultProps = {};

export default ControlStatic;
